const TOPICS = [
  {
    title: '2026暑期档必看',
    desc: '暑期档热映大片合集，动作科幻喜剧一网打尽',
    count: '48部',
    icon: 'ri-sun-line',
    bg: 'bg-primary-100',
    text: 'text-primary-700',
  },
  {
    title: '豆瓣高分经典',
    desc: '8.5分以上口碑佳作，影史不可错过的经典',
    count: '126部',
    icon: 'ri-star-line',
    bg: 'bg-accent-100',
    text: 'text-accent-700',
  },
  {
    title: '华语电影精选',
    desc: '国产好片集中营，从文艺到商业全收录',
    count: '312部',
    icon: 'ri-china-railway-line',
    bg: 'bg-secondary-200',
    text: 'text-secondary-800',
  },
  {
    title: '好莱坞大片',
    desc: '漫威DC动作巨制，特效拉满的视听盛宴',
    count: '258部',
    icon: 'ri-film-line',
    bg: 'bg-primary-100',
    text: 'text-primary-700',
  },
  {
    title: '日韩影视专区',
    desc: '日剧韩影一网打尽，追剧党不可错过',
    count: '196部',
    icon: 'ri-earth-line',
    bg: 'bg-accent-100',
    text: 'text-accent-700',
  },
  {
    title: '动画动漫天地',
    desc: '宫崎骏到新海诚，二次元世界的极致美学',
    count: '173部',
    icon: 'ri-emotion-line',
    bg: 'bg-secondary-200',
    text: 'text-secondary-800',
  },
  {
    title: '悬疑烧脑集锦',
    desc: '反转再反转，让你猜不到结局的精品悬疑',
    count: '89部',
    icon: 'ri-lightbulb-line',
    bg: 'bg-primary-100',
    text: 'text-primary-700',
  },
  {
    title: '恐怖惊悚之夜',
    desc: '胆小慎入！全球恐怖惊悚电影精选合集',
    count: '64部',
    icon: 'ri-ghost-line',
    bg: 'bg-accent-100',
    text: 'text-accent-700',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精选专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按类型与主题精心整理的电影资源合集，快速找到你想看的
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.title}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer border border-secondary-100/60"
            >
              <div
                className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg ${topic.bg} ${topic.text} mb-3 md:mb-4`}
              >
                <i className={`${topic.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                {topic.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2 line-clamp-2 leading-relaxed">
                {topic.desc}
              </p>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}